<div class="flex margin-top margin-bottom">
	<div class="flex-0">
		<div class="calendar full-height flex column">
			<div class="flex-0 padding-small align-center">
				<h4>{{ monthNowDate }}</h4>
			</div>
			<div class="flex-1 padding-small padding-left padding-right flex center justify-center">
				<h2>{{ dayNowDate }}</h2>
			</div>
		</div>
	</div>
	<div class="flex-1">
		<div class="card margin-left">
			<h2 class="margin-bottom-small">Hello, {{ userName }}!</h2>
			<h4>Here your scheduled activities for Today.</h4>
		</div>
	</div>
</div>
<bt-loader [loaderId]="firstLoaderId">
	@if (orders.data) {
		<ng-container>
			<h4>Ongoing Orders</h4>
			<div class="card margin-top">
				@if (orders.data?.length) {
					<ng-container>
						<table class="margin-bottom-small">
							<tr>
								@for (col of gridColumns; track col) {
									<th [ngStyle]="{ width: col.width ? col.width + 'px' : null }">{{ col.title }}</th>
								}
							</tr>
							@for (item of orders.data; track item) {}
							<tr *ngFor="let item of orders.data">
								@for (col of gridColumns; track col) {
									<td>
										@if (!col.type || col.type === gridColumnTypeEnum.default) {
											<ng-container>
												{{ item[col.field] }}
											</ng-container>
										}
										@if (col.type === gridColumnTypeEnum.date) {
											<ng-container>
												{{ item[col.field] ? (item[col.field] | date: 'd MMM y') : ' - not set - ' }}
											</ng-container>
										}
										@if (col.type === gridColumnTypeEnum.icon) {
											<ng-container>
												<div
													class="pointer flex center justify-center"
													(click)="item.showMenu = !item.showMenu">
													<bt-menu
														[show]="item.showMenu"
														(hidden)="item.showMenu = false"
														(showed)="item.showMenu = true">
														<div class="menu-item" (click)="onOrderInfo(item)">
															<i class="fa fa-info"></i>
															Order info
														</div>
													</bt-menu>
												</div>
											</ng-container>
										}
									</td>
								}
							</tr>
						</table>
						<bt-paginator
							[pageNumber]="orders.page"
							[pageSize]="orders.size"
							[totalNumber]="orders.total"
							(clickPage)="getOngoingOrders($event)"></bt-paginator>
					</ng-container>
				}
				@if (orders.data && !orders.data.length && !orders.page) {
					<div class="padding-large flex column center grey margin-top-large">
						<i class="fa fa-search big margin-bottom-smallest"></i>
						<h4>No data found</h4>
					</div>
				}
			</div>
			<bt-loader [loaderId]="secondLoaderId">
				@if (rejectedShots.data) {
					<div class="flex margin-top">
						<div class="flex-1 margin-right-x-small">
							<h4 class="margin-bottom">Rejected Shots</h4>
							<input style="display: none" type="file" (change)="onReplaceShotUpload($event)" #replaceShot />
							@if (rejectedShots.dataToView?.length) {
								<ng-container>
									@for (item of rejectedShots.dataToView; track item) {
										<div class="flex margin-bottom-small card">
											<div class="flex-0 padding-right flex center">
												<bt-menu
													[show]="item.showMenu"
													(hidden)="item.showMenu = false"
													(showed)="item.showMenu = true">
													<div class="menu-item" (click)="onReplaceShot(item)">
														<i class="fa fa-exchange"></i>
														Replace shot
													</div>
													<div class="menu-item" (click)="onOrderInfo(item, item.modelId)">
														<i class="fa fa-info"></i>
														Go to order info
													</div>
												</bt-menu>
											</div>
											<div class="flex-0 margin-right-small thumbnail border red">
												<div class="img-container">
													<img [src]="item.imgPath" [preview]="item.shotTypeName" />
												</div>
											</div>
											<div class="flex-1">
												<div class="padding-bottom-x-small truncate">
													Order:
													<b>{{ item.orderNumber }}</b>
												</div>
												<div class="padding-bottom-x-small truncate">
													Style:
													<b>{{ item.styleFullName }}</b>
												</div>
												<div class="padding-bottom-x-small truncate">
													Brand:
													<b>{{ item.brandName }}</b>
												</div>
												<div class="truncate">
													Shot type:
													<b>{{ item.shotTypeName }}</b>
												</div>
											</div>
										</div>
									}
									<bt-paginator
										[pageNumber]="rejectedShots.pageNumber"
										[pageSize]="rejectedShots.pageSize"
										[totalNumber]="rejectedShots.data.length"
										(clickPage)="setRejectedShotsToView($event)"></bt-paginator>
								</ng-container>
							}
							@if (rejectedShots.dataToView && !rejectedShots.dataToView.length) {
								<div class="padding-large flex column center grey margin-top-large">
									<i class="fa fa-search big margin-bottom-smallest"></i>
									<h4>No data found</h4>
								</div>
							}
						</div>
						<div class="flex-1 margin-left-x-small">
							<h4 class="margin-bottom">Upload your shots</h4>
							<div class="card">
								<div class="margin-bottom-small">Select the order in witch you want to upload your shots</div>
								<bt-autocomplete
									[datasource]="autocompleteOrders.data"
									[settings]="autocompleteOrders.settings"
									[page]="autocompleteOrders.page"
									(open)="onOpenOrdersAutocomplete()"
									(nextPage)="getAutocompleteOrders(autocompleteOrders.page + 1)"
									(filterChange)="onOrdersAutocompleteFilterChange($event)"
									(selected)="onSelectOrderToUploadShots($event)"></bt-autocomplete>
								<div
									class="margin-top thumbnail upload-zone flex column center justify-center"
									[ngClass]="{
										'disabled-area': !autocompleteOrders.selected || inUploadingShots,
										highlight: highlightDropArea && autocompleteOrders.selected && !inUploadingShots
									}"
									[title]="!autocompleteOrders.selected ? 'Select a order' : ''"
									(dragover)="onDragOver($event, true)"
									(drop)="onDrop($event)">
									<input style="display: none" multiple type="file" (change)="onImagesUpload($event)" #selectImages />
									<button [disabled]="!autocompleteOrders.selected" (click)="selectImages.click()">
										<i class="fa fa-upload"></i>
										Upload shots
									</button>
									<div class="margin-top margin-bottom">or</div>
									<div>Drag them here from your folder</div>
								</div>
							</div>
						</div>
					</div>
				}
			</bt-loader>
		</ng-container>
	}
</bt-loader>
